import { AuthProviderProps, User } from 'oidc-react';

export const oidcConfig: AuthProviderProps = {
  onSignIn: async (user: User | null) => {
    if (user?.access_token) {
      localStorage.setItem('authToken', user.access_token);
    }
  },
  onSignOut: async () => {
    localStorage.removeItem('authToken');
  },
  authority: import.meta.env.REACT_APP_AUTHORITY,
  clientId: import.meta.env.REACT_APP_CLIENT_ID,
  clientSecret: import.meta.env.REACT_APP_CLIENT_SECRET,
  redirectUri: import.meta.env.REACT_APP_REDIRECT_URL,
  silentRedirectUri: window.location.origin,
  postLogoutRedirectUri: import.meta.env.REACT_APP_POST_LOGOUT_REDIRECT_URL,
  scope: 'openid profile email offline_access',
  responseType: 'code',
  automaticSilentRenew: true,
};
